import _ from 'underscore';

import { AppState } from '~src/app/state/AppState';
import { currentUserIsOwnerOrAdmin, hasRunNowPermission } from '~src/app/utils/MixedContentHelpers';
import { Messages } from '~src/codegen/Localize';
import { publishedConnectionTableExtractsRefreshNow } from '~src/publishedConnectionTable/actions/PublishedConnectionTableExtractsRefreshNowAction';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { IRefreshExtractAction } from '~src/ts/ServerApi/types/actionNames';
import { IPublishedConnectionTable } from '~src/ts/ServerApi/types/IPublishedConnectionTable';

import { EntityActionNames, IEntityAction } from './IEntityAction';

function allItemsPublishedConnectionTable(targetItems: IContentInfo[]): boolean {
  return targetItems.length >= 1 && _.all(targetItems, (item => item.contentType === 'publishedConnectionTable'));
}

function allItemsFromSamePublishedConnection(targetItems: IContentInfo[]): boolean {
  if (targetItems.length >= 1) {
    const publishedConnectionId = (targetItems[0] as unknown as IPublishedConnectionTable).publishedConnectionId;
    return _.all(targetItems, (item => (item as unknown as IPublishedConnectionTable).publishedConnectionId === publishedConnectionId));
  }
  return false;
}

function canRunNow(state: AppState, targetItems: IContentInfo[]): boolean {
  return targetItems.length >= 1 && currentUserIsOwnerOrAdmin(state, targetItems[0]) && hasRunNowPermission(state);
}

export const PublishedConnectionTableExtractsRefreshNowAction: IEntityAction<IContentInfo<'publishedConnectionTable'>, IRefreshExtractAction> = {
  name: EntityActionNames.PublishedConnectionTableExtractsRefreshNow,
  translateName: Messages.publishedConnectionTableExtractsRefreshNow_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return allItemsPublishedConnectionTable(targetItems);
  },
  isClickable: (availableActions: IRefreshExtractAction, targetItems: IContentInfo[], state: AppState) => {
    return !!(availableActions && availableActions.refreshExtract) && allItemsFromSamePublishedConnection(targetItems)
      && canRunNow(state, targetItems);
  },
  createReduxAction: (targetItems: IContentInfo[]) => publishedConnectionTableExtractsRefreshNow(targetItems)
};
